export default __webpack_public_path__ + "static/media/mikes.aeb5a846.jpg";